import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'

export const agentFinderAppBuilder = DataRouterApplicationBuilder.create('agent-finder')
